export default __webpack_public_path__ + "a732a12eb077422324070eba5dd22533.ttf";